import { render, staticRenderFns } from "./ItensDespesas.vue?vue&type=template&id=64d4a3b6"
import script from "./ItensDespesas.vue?vue&type=script&lang=js"
export * from "./ItensDespesas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports